import React,{ useState, useEffect, useContext } from 'react';
import { Outlet, NavLink } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import useWindowSize from './hooks/useGatsbyWindowSize';
import useBodyPathClasses from './hooks/useBodyPathClasses';
/* import AnimatedCursor from "react-animated-cursor"; */

import {
  CookieConsentProvider,
  CookieBanner,
  FloatingConsentInfo,
  CookieService
} from "@vantezzen/react-cookie-banner";


import Navbar from "./component/Navbar";
import Footer from "./component/Footer";


import { ThemeContext } from './context/ThemeContext';
import './index.css';

function App() {

 useBodyPathClasses();


const {width,height} = useWindowSize();
const vertical = useMediaQuery({ query: `(orientation: portrait)` }); //detecting orientation vs max-width: 821px;

const theme = useContext(ThemeContext);



  useEffect(()=> {
    //console.log(width,height);
    theme.dispatch({pushOut:false, width:width, height:height, vertical:vertical,type: 'viewport' });

  },[width,height,vertical])

  useEffect(()=> {
  var touchRegionElement = document.getElementById('app');
  /*  var _cursor_ = touchRegionElement.getElementsByTagName('div')[0]; */

/*  function showCoordinates(e) {
     _cursor_.style.left = `${e.touches[0].clientX}`;
     _cursor_.style.top = `${e.touches[0].clientY}`;
  }*/

/*
  touchRegionElement.addEventListener('touchstart', showCoordinates);
  touchRegionElement.addEventListener('touchend', showCoordinates);
  touchRegionElement.addEventListener('touchmove', showCoordinates);
  */

  },[width])

  return (

    <div id="app">
  {/*  <AnimatedCursor
    className="cs"
    data-cursor="1"
    showSystemCursor={true}
    trailingSpeed={12}
    innerSize={18}
      outerSize={8}
      color='255, 255, 255'
      outerAlpha={0.1}
      innerScale={0.7}
      outerScale={2}
      outerSize={25}
      outerStyle={{
        boxShadow:'0 0 3px #fff, -3px 0 8px #f0f, 3px 0 8px #0ff'
  }}
  innerStyle={{
    backgroundColor: 'transparent'
  }}
      hasBlendMode={true}
      clickables={[
        'a',
        'input[type="text"]',
        'input[type="email"]',
        'input[type="number"]',
        'input[type="submit"]',
        'input[type="image"]',
        'label[for]',
        'select',
        'textarea',
        'button',
        '.link'
      ]}
  />*/}
   <Navbar />

   <div id="main" style={{minHeight:100+'vh',width:'100%'}} className="bg-white relative">
     <div style={{zIndex:99999}} className=" absolute left-3 md:left-4 lg:left-12 top-1 md:top-2">
       <a href="/" aria-label="home" className="">
         <svg className="brandLogo" width="80" height="90"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 180 180"
         fill="currentColor">
         <path d="M168.7,44.3l10-29.1l-81,0.3v64.2L75.4,15H40.9L4.2,121.6h34.1l4.4-15.2h30l4.6,15.2h20.3h14.4h18.3V84.9h24.3
         	l9.2-26.8l-33.6,0.1v-14H168.7z M49.9,82.2l7.9-27.6l8,27.6H49.9z"/>

         </svg>
       </a>
     </div>
     <Outlet/>
</div>


<Footer/>

<CookieConsentProvider>
      <CookieBanner
        id="ckb"
        lang={{
    title: "Cookie consent",
    description:
      'We use cookies to enhance your browsing experience. By clicking "Accept All", you consent to our use of cookies.',
    required: "Required",

    privacyPolicyInfo: "For more information, please visit our",
    privacyPolicy: "Privacy Policy",

    acceptAll: "Accept all",
    saveSelection: "Save selection",
    disableAll: "Disable all",

    essential: "Essential",
    marketing: "Marketing",
    analytics: "Analytics",
    other: "Other",
  }}
    />
      <FloatingConsentInfo />
      <CookieService>
        {/* External scripts/components go here */}

      </CookieService>
    </CookieConsentProvider>

</div>


  );
}

export default App;
